import { supabase } from '../supabase.js';
import { CHAT_API_BASE } from '../config.js';
import { SupabaseReceptionStore } from './supabaseReceptionStore.js';
import type { ReceptionStore } from './receptionStore.js';

// Composition root for the reception data layer: the one place the Supabase
// client + chat API origin are bound to the ReceptionStore port (the
// apps/menu store.ts pattern). Tests call setReceptionStore() with a fake.
let active: ReceptionStore = new SupabaseReceptionStore(supabase, CHAT_API_BASE);

export function getReceptionStore(): ReceptionStore {
  return active;
}

/** Override the active store — for tests, or an alternative backend. */
export function setReceptionStore(store: ReceptionStore): void {
  active = store;
}
